module.exports = __webpack_public_path__ + "static/img/home_banner.c13fb7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_banner.png
// module id = QwQy
// module chunks = 3